(() => {
  if (window.__mustflorRatingLinksLoaded) return;
  window.__mustflorRatingLinksLoaded = true;

  const REVIEW_HASH = '#vstar-reviews';
  const REVIEW_HASHES = new Set([REVIEW_HASH, '#reviews', '#mustflor-customer-reviews']);
  const ignoredSelector =
    '.mustflor-review-story, #vstar-reviews, #trustoo-product-reviews, #trustoo-card-carousel-widget, #tt-carousel, #judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg';

  const style = document.createElement('style');
  style.textContent = `
    .mustflor-rating-link {
      position: relative;
      z-index: 3;
      display: inline-flex;
      align-items: center;
      gap: .35rem;
      color: inherit;
      text-decoration: none !important;
      cursor: pointer;
      vertical-align: middle;
    }
    .card-information > .mustflor-rating-link { margin-top: .4rem; }
    .mustflor-rating-link .rating-count,
    .mustflor-rating-link .rating-text { margin: 0; }
    .mustflor-rating-link:hover {
      opacity: .78;
      text-decoration: none !important;
    }
    .mustflor-rating-link:focus-visible {
      outline: .1rem solid currentColor;
      outline-offset: .25rem;
      border-radius: .2rem;
    }
  `;
  document.head.appendChild(style);

  const insideReviewContent = (element) => Boolean(element?.closest(ignoredSelector));

  const productHrefFrom = (element) => {
    if (!element) return null;

    const card = element.closest(
      '.card-wrapper, .product-card-wrapper, .card, .grid__item, .product__info-container'
    );
    const productLink = card?.querySelector('a[href*="/products/"]');
    if (productLink) return productLink.getAttribute('href')?.split('#')[0] || null;

    if (window.location.pathname.includes('/products/')) {
      return `${window.location.pathname}${window.location.search}`;
    }

    return null;
  };

  const withReviewHash = (href) => {
    if (!href) return null;

    try {
      const url = new URL(href, window.location.origin);
      url.hash = 'vstar-reviews';
      return url.origin === window.location.origin
        ? `${url.pathname}${url.search}${url.hash}`
        : url.toString();
    } catch (error) {
      return `${href.split('#')[0]}${REVIEW_HASH}`;
    }
  };

  const reviewTarget = () =>
    document.querySelector(
      '#vstar-reviews, #trustoo-product-reviews, #judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg, [id*="trustoo"][id*="review"], [class*="trustoo"][class*="review"]'
    );

  const scrollWhenReady = () => {
    let attempts = 0;

    const tryScroll = () => {
      const target = reviewTarget();
      if (!target) return false;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    };

    if (tryScroll()) return;

    const timer = window.setInterval(() => {
      attempts += 1;
      if (tryScroll() || attempts >= 40) window.clearInterval(timer);
    }, 150);
  };

  const makeLink = (href) => {
    const link = document.createElement('a');
    link.className = 'mustflor-rating-link';
    link.href = href;
    link.setAttribute('aria-label', '查看這項商品的顧客評價');
    return link;
  };

  const wrapNativeRating = (rating) => {
    if (!rating || insideReviewContent(rating) || rating.closest('.mustflor-rating-link')) return;

    const href = withReviewHash(productHrefFrom(rating));
    if (!href) return;

    const parent = rating.parentElement;
    if (!parent) return;

    const siblings = Array.from(parent.children);
    const ratingText = siblings.find((node) => node.classList?.contains('rating-text'));
    const ratingCount = siblings.find((node) => node.classList?.contains('rating-count'));

    const link = makeLink(href);
    parent.insertBefore(link, rating);
    link.appendChild(rating);
    if (ratingText) link.appendChild(ratingText);
    if (ratingCount) link.appendChild(ratingCount);

    rating.dataset.mustflorReviewLink = 'true';
    if (rating.getAttribute('role') === 'link') rating.setAttribute('role', 'img');
    rating.removeAttribute('tabindex');
  };

  const looksLikeCount = (node) => {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
    const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    return /^\(?\d+\)?(?:\s*(?:則)?\s*(?:評論|評價|reviews?))?$/i.test(text);
  };

  const wrapPluginRating = (rating) => {
    if (!rating || insideReviewContent(rating) || rating.closest('.mustflor-rating-link')) return;

    const href = withReviewHash(productHrefFrom(rating));
    if (!href) return;

    const existingAnchor = rating.closest('a');
    if (existingAnchor) {
      existingAnchor.href = href;
      existingAnchor.classList.add('mustflor-rating-link');
      existingAnchor.setAttribute('aria-label', '查看這項商品的顧客評價');
      return;
    }

    const parent = rating.parentElement;
    if (!parent) return;

    const next = rating.nextElementSibling;
    const link = makeLink(href);
    parent.insertBefore(link, rating);
    link.appendChild(rating);
    if (looksLikeCount(next)) link.appendChild(next);
  };

  const scan = () => {
    document
      .querySelectorAll('.card-information .rating, .card__information .rating, .rating-wrapper .rating')
      .forEach(wrapNativeRating);

    document
      .querySelectorAll(
        '.collection-icon-list.vstar-star, .card-information .vstar-star, .card__information .vstar-star, .product__info-container .vstar-star'
      )
      .forEach(wrapPluginRating);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a.mustflor-rating-link');
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    if (
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash === REVIEW_HASH
    ) {
      event.preventDefault();
      history.replaceState(null, '', REVIEW_HASH);
      scrollWhenReady();
    }
  });

  let scanFrame = null;
  const scheduleScan = () => {
    if (scanFrame) return;
    scanFrame = window.requestAnimationFrame(() => {
      scanFrame = null;
      scan();
    });
  };

  const observer = new MutationObserver(scheduleScan);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', () => {
    scan();
    if (REVIEW_HASHES.has(window.location.hash)) {
      window.setTimeout(scrollWhenReady, 120);
    }
  });

  window.addEventListener('load', scan);
  window.addEventListener('hashchange', () => {
    if (REVIEW_HASHES.has(window.location.hash)) scrollWhenReady();
  });
})();
